import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-g2-forms-modal',
  templateUrl: './g2-forms-modal.component.pug',
  styleUrls: ['./g2-forms-modal.component.scss'],
  standalone: false
})
export class G2FormsModalComponent implements OnInit {
  g2FormsUrl: SafeResourceUrl | string | null = null;
  popupContentImage = '/assets/images/popup-content.png';
  reviewAlreadyExists: boolean = false;

  constructor(
    public bsModalRef: BsModalRef
  ) {}

  ngOnInit(): void {
    // ngx-bootstrap sets initialState properties directly on the component
    // This ensures reviewAlreadyExists is properly initialized
    if (this.reviewAlreadyExists === undefined) {
      this.reviewAlreadyExists = false;
    }
  }

  closeModal(): void {
    this.bsModalRef.hide();
  }
}

